import React, { Component } from 'react'
import { connect } from 'react-redux'

class WebSocketEventHandler extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return(
            <div />
        )
    }
}

const mapStateToProps = state => {
    return {
        messages: state.messages
    }
}

export default connect(mapStateToProps)(WebSocketEventHandler)



// WEBPACK FOOTER //
// ./src/components/WebSocketEventHandler.js